import { checkFeatureFlag } from './chunk-FKQPHPFM.mjs';
import { useSubscription } from './chunk-P73FS5FX.mjs';
import { useAuthContext } from './chunk-K3UDKV2P.mjs';
import { graphql } from './chunk-NWN55YVG.mjs';
import { useMemo } from 'react';

var FEATURE_FLAGS_SUBSCRIPTION = graphql(
  /* GraphQL */
  `
  subscription FeatureFlags {
    feature_flag {
      id
      name
      conditions
    }
  }
`
);
function useFeatureFlagSubscription(url) {
  const { user, isSignedIn } = useAuthContext();
  const subscription = useSubscription({
    hasuraUrl: url,
    query: FEATURE_FLAGS_SUBSCRIPTION.toString(),
    enabled: isSignedIn
  });
  const processedFlags = useMemo(() => {
    if (!subscription.data) {
      return null;
    }
    return subscription.data.feature_flag.reduce(
      (acc, flag) => {
        acc[flag.name] = checkFeatureFlag(flag.conditions, (user == null ? void 0 : user.id) || "");
        return acc;
      },
      {}
    );
  }, [subscription.data, user == null ? void 0 : user.id]);
  return {
    data: processedFlags,
    isLoading: subscription.isLoading,
    error: subscription.error
  };
}

export { FEATURE_FLAGS_SUBSCRIPTION, useFeatureFlagSubscription };
//# sourceMappingURL=chunk-46BXQPCJ.mjs.map
//# sourceMappingURL=chunk-46BXQPCJ.mjs.map